import axios from "axios";
import * as React from "react";
import { useMutation } from "react-query";
import { useFormik } from "formik";
import {
  PrimaryButton,
  TextField,
  Label,
  DefaultButton,
  Dropdown,
} from "@fluentui/react";
import {
  ButtonContainer,
  labelStyles,
  StyledContent,
  StyledContainer,
} from "./ForgotPasswordForm.styles";
import { schema } from "./ForgotPasswordForm.utils";
import { useNavigate } from "react-router-dom";
import { textFieldStyles } from "styles/formStyles";

const groupOptions = [
  { key: "employee", text: "employee" },
  { key: "employer", text: "Employer" },
];

const SignInForm = () => {
  const navigate = useNavigate();
  const handleError = (error) => {
    if (error?.response?.status === 401 && !error?.response?.data?.success) {
      alert(error?.response?.data?.error);
    } else {
      alert(error?.message);
    }
  };
  const [group, setGroup] = React.useState("employer");
  const handleSuccess = () => {
    alert("Password is changed.");
    resetForm();
    navigate("/login");
  };

  const mutation = useMutation(
    (data) => {
      return axios.post(
        "https://gxiv4d2ndh.execute-api.us-east-1.amazonaws.com/dev/signup",
        data,
        {
          headers: {},
        }
      );
    },
    { onError: handleError, onSuccess: handleSuccess }
  );

  const { values, touched, errors, handleChange, handleSubmit, resetForm } =
    useFormik({
      initialValues: {
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        group: "employee",
      },
	    validationSchema: schema,
      onSubmit: (values) => {
        const { name, email, password } = values || {};
        mutation.mutate({
          name,
          email,
          password,
          group,
        });
      },
    });

  return (
    <StyledContainer className="main-container">
      <StyledContent>
        <Label styles={labelStyles}>Name</Label>
        <TextField
          value={values.name}
          onChange={handleChange}
          name="name"
          type="text"
          styles={textFieldStyles}
          errorMessage={touched?.name ? errors?.name : undefined}
        />
      </StyledContent>
      <StyledContent>
        <Label styles={labelStyles}>Email</Label>
        <TextField
          value={values.email}
          onChange={handleChange}
          name="email"
          type="email"
          styles={textFieldStyles}
          errorMessage={touched?.email ? errors?.email : undefined}
        />
      </StyledContent>
      <StyledContent>
        <Label styles={labelStyles}>New Password</Label>
        <TextField
          value={values.password}
          onChange={handleChange}
          name="password"
          type="password"
          styles={textFieldStyles}
          errorMessage={touched?.password ? errors?.password : undefined}
        />
      </StyledContent>
      <StyledContent>
        <Label styles={labelStyles}>Confirm Password</Label>
        <TextField
          value={values.confirmPassword}
          onChange={handleChange}
          name="confirmPassword"
          type="password"
          styles={textFieldStyles}
          errorMessage={
            touched?.confirmPassword ? errors?.confirmPassword : undefined
          }
        />
      </StyledContent>
      <StyledContent>
        <Label styles={labelStyles}>Group</Label>
        <Dropdown
          name="group"
          defaultSelectedKey={group}
          styles={textFieldStyles}
          placeholder="Select an option"
          options={groupOptions || []}
          onChange={(e, selectedOption) => {
            setGroup(selectedOption.text);
          }}
        />
      </StyledContent>

      <ButtonContainer>
        <PrimaryButton
          onClick={handleSubmit}
          text={"Submit"}
          disabled={mutation.isLoading}
        />
        <DefaultButton
          text={"Cancel"}
          styles={{ root: { float: "right", marginRight: "20px" } }}
          onClick={() => {
            navigate("/login");
          }}
        />
      </ButtonContainer>
    </StyledContainer>
  );
};

export default SignInForm;
